var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',_vm._b({attrs:{"items":_setup.items,"label":_vm.label},model:{value:(_setup.modelValue),callback:function ($$v) {_setup.modelValue=$$v},expression:"modelValue"}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }